import { defineRecipe } from '@chakra-ui/react';

export const textareaRecipe = defineRecipe({
	base: {
		px: '4',
		fontSize: 'sm',
		fontWeight: 'medium',
		borderRadius: 'md',
		borderColor: { base: '{colors.neutral.300}', _dark: '{colors.neutral.600}' },
		bg: { base: 'white', _dark: '{colors.neutral.800}' },
		_focusVisible: {
			focusRingColor: { base: '{colors.blue.500}', _dark: '{colors.blue.500}' },
			focusRingWidth: '0',
		},
		_invalid: {
			focusRingColor: 'error',
			borderColor: 'error'
		}
	},
	variants: {
		variant: {
			outline: {
				borderColor: { base: '{colors.neutral.300}', _dark: '{colors.neutral.600}' }
			},
		}
	}
});